"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4504],{

/***/ 79992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ImagePosition; },
/* harmony export */   "k": function() { return /* binding */ ListCta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74183);




var ImagePosition;
(function(ImagePosition) {
    ImagePosition["Left"] = "left";
    ImagePosition["Right"] = "right";
})(ImagePosition || (ImagePosition = {}));
var ListCta = function(param) {
    var imgSrc = param.imgSrc, imgWidth = param.imgWidth, imgHeight = param.imgHeight, _items = param.items, items = _items === void 0 ? [] : _items, className = param.className, _imagePosition = param.imagePosition, imagePosition = _imagePosition === void 0 ? ImagePosition.Left : _imagePosition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("bg-footer rounded text-footer-foreground grid lg:grid-flow-col p-6 gap-4 relative shadow-lg [&>*]:border-b-[1px] [&>*]:lg:border-b-0 [&>*:not(:last-child)]:lg:border-r-[1px] [&>*:not(:last-child)]:border-teal-300", className),
        children: [
            imagePosition === ImagePosition.Left && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("hidden lg:flex items-center lg:col-span-3 px-4"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative -mt-16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: imgSrc,
                        width: imgWidth,
                        height: imgHeight
                    })
                })
            }),
            items.map(function(it) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 col-span-12 lg:col-span-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: "font-bold text-xl mb-2",
                            children: it.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "list-disc marker:text-listMarker",
                            children: it.list.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "mb-2 ml-6 font-semibold",
                                    children: item.text
                                }, item.text);
                            })
                        })
                    ]
                }, it.title);
            }),
            imagePosition === ImagePosition.Right && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("hidden lg:flex items-center lg:col-span-3 justify-self-end"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative -mt-16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: imgSrc,
                        width: imgWidth,
                        height: imgHeight
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 65558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_UserAvatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8222);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19475);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46035);
/* harmony import */ var _features_usersSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97219);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58020);
/* harmony import */ var _components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59743);
/* harmony import */ var _components_ui_badge__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95034);
/* harmony import */ var _components_ui_separator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3127);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74183);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94916);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35739);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5097);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(49525);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(72175);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(86871);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(82701);
/* harmony import */ var _util_format__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16685);
/* harmony import */ var _features_timezoneSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70118);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1438);
/* harmony import */ var _util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80995);



















var CaseCard = function(param) {
    var caseId = param.caseId;
    var ref, ref1;
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_11__/* .selectCaseById */ .pJ)(state, caseId);
    });
    var userId = currentCase === null || currentCase === void 0 ? void 0 : currentCase.user;
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return userId ? (0,_features_usersSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectUserById */ .Ls)(state, userId) : null;
    });
    var timezone = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_features_timezoneSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectTimezone */ .pE);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoginOverlayVisible = ref2[0], setIsLoginOverlayVisible = ref2[1];
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    var isOpenCase = !auth.isAuthenticated && (currentCase === null || currentCase === void 0 ? void 0 : currentCase.public) || auth.isAuthenticated;
    var onFocus = (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_16__/* .useStableCallback */ .R)(function() {
        if (!isOpenCase) {
            setIsLoginOverlayVisible(true);
        }
    });
    var onBlur = (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_16__/* .useStableCallback */ .R)(function() {
        setIsLoginOverlayVisible(false);
    });
    if (!currentCase) {
        return null;
    }
    //convert expertise to set to remove duplicates
    var expertises = new Set((ref = currentCase.expertises) === null || ref === void 0 ? void 0 : ref.map(function(expertise) {
        return expertise.title;
    }));
    var isPublic = currentCase.public;
    var isUpcoming = currentCase.scheduled_to > Date.now() / 1000;
    var description = currentCase.excerpt;
    var title = currentCase.title;
    var state = currentCase === null || currentCase === void 0 ? void 0 : currentCase.state;
    var isPlaceholder = state === _constants__WEBPACK_IMPORTED_MODULE_15__/* .CaseStatuses.TENTATIVE */ .HM.TENTATIVE;
    var isClosed = state === _constants__WEBPACK_IMPORTED_MODULE_15__/* .CaseStatuses.CLOSED */ .HM.CLOSED;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCard */ .hZ, {
        className: "flex flex-col hover:bg-teal-50",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardHeader */ .B1, {
                className: "px-6 pt-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between gap-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-wrap gap-1",
                            children: isPublic ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_badge__WEBPACK_IMPORTED_MODULE_9__/* .Badge */ .C, {
                                variant: "secondary",
                                className: "bg-teal-200",
                                children: "Free"
                            }) : null
                        })
                    }),
                    isPlaceholder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                        className: "decoration-0 font-semibold text-lg line-clamp-2",
                        variant: "large",
                        children: title
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/case/".concat(caseId),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                            className: "decoration-0 font-semibold text-lg line-clamp-2",
                            variant: "large",
                            asChild: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: title
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardContent */ .w9, {
                className: "px-6 gap-4 h-full flex flex-col justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            !!description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardDescription */ .ht, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_17__.cn)("animate flex items-center absolute inset-0 pointer-events-none bg-teal-50 backdrop-blur-2xl", {
                                            "opacity-0": !isLoginOverlayVisible
                                        }),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                "Become a Casehub member to see more. ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "Free trial for 14 days"
                                                }),
                                                ", cancel any time."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                                        variant: "default",
                                        className: "line-clamp-6",
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-wrap gap-1 text-muted-foreground text-xs",
                                children: (ref1 = Array.from(expertises)) === null || ref1 === void 0 ? void 0 : ref1.map(function(exp) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            "#",
                                            exp
                                        ]
                                    }, exp);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardIcons */ .qB, {
                                children: [
                                    (!isUpcoming || currentCase.comment_count > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                        variant: "badge",
                                        size: "subtle",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                className: "w-4 h-4"
                                            }),
                                            currentCase.comment_count
                                        ]
                                    }),
                                    (isUpcoming || currentCase.register_count > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                            variant: "badge",
                                            size: "subtle",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    className: "w-4 h-4"
                                                }),
                                                currentCase.register_count,
                                                "/",
                                                currentCase.register_max
                                            ]
                                        })
                                    })
                                ]
                            }),
                            isUpcoming && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex gap-x-2 text-xs text-muted-foreground items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                className: "w-4 h-4"
                                            }),
                                            " ",
                                            (0,_util_format__WEBPACK_IMPORTED_MODULE_13__/* .formatDate */ .p6)({
                                                ts: currentCase.scheduled_to,
                                                format: "medium",
                                                tz: timezone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex gap-x-2 text-xs text-muted-foreground items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                className: "w-4 h-4"
                                            }),
                                            " ",
                                            currentCase.duration || _constants__WEBPACK_IMPORTED_MODULE_15__/* .DEFAULT_SESSION_DURATION_IN_MINUTES */ .pg,
                                            " min"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_separator__WEBPACK_IMPORTED_MODULE_10__/* .Separator */ .Z, {
                                className: "mb-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardActions */ .Je, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onMouseEnter: onFocus,
                            onMouseLeave: onBlur,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                asChild: true,
                                variant: "outline",
                                size: "lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: isLoginOverlayVisible ? "/pricing" : "/case/".concat(currentCase.id),
                                    children: [
                                        isLoginOverlayVisible ? "Become a member" : "Enter case",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            className: "w-4 h-4"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardFooter */ .At, {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_17__.cn)("flex px-6 py-2 items-center space-x-4", {
                    "bg-gray-200": isClosed,
                    "bg-cardFooter": !isClosed
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserAvatar__WEBPACK_IMPORTED_MODULE_3__/* .UserAvatar */ .Y, {
                        userId: userId,
                        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_17__.cn)("my-4")
                    }),
                    !!user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-sm font-medium leading-none",
                                children: (0,_util_format__WEBPACK_IMPORTED_MODULE_13__/* .formatName */ .KY)(user)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: user.position
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CaseCard);


/***/ }),

/***/ 59743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ CaseCardFooter; },
/* harmony export */   "B1": function() { return /* binding */ CaseCardHeader; },
/* harmony export */   "Je": function() { return /* binding */ CaseCardActions; },
/* harmony export */   "hZ": function() { return /* binding */ CaseCard; },
/* harmony export */   "ht": function() { return /* binding */ CaseCardDescription; },
/* harmony export */   "qB": function() { return /* binding */ CaseCardIcons; },
/* harmony export */   "w9": function() { return /* binding */ CaseCardContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88426);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74183);






var CaseCard = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("bg-background text-foreground shadow-lg rounded-lg border-[1px] border-card-border overflow-hidden", className),
        ref: ref
    }, props));
});
CaseCard.displayName = "Card";
var CaseCardHeader = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col gap-2", className),
        ref: ref
    }, props));
});
CaseCard.displayName = "CaseCardHeader";
var CaseCardContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col p-4", className),
        ref: ref
    }, props));
});
CaseCard.displayName = "CaseCardContent";
var CaseCardIcons = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex w-full items-center gap-2", className),
        ref: ref
    }, props));
});
CaseCard.displayName = "CaseCardIcons";
var CaseCardDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-sm relative", className),
        ref: ref
    }, props));
});
CaseCard.displayName = "CaseCardDescription";
var CaseCardActions = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("", className),
        ref: ref
    }, props));
});
CaseCard.displayName = "CaseCardActions";
var CaseCardFooter = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("mt-auto", className),
        ref: ref
    }, props));
});
CaseCard.displayName = "CaseCardFooter";



/***/ }),

/***/ 35895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SP": function() { return /* binding */ TabsTrigger; },
/* harmony export */   "dr": function() { return /* binding */ TabsList; },
/* harmony export */   "mQ": function() { return /* binding */ Tabs; },
/* harmony export */   "nU": function() { return /* binding */ TabsContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60434);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74183);
"use client";






var Tabs = _radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
var TabsList = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_2__/* .List */ .aV, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("inline-flex h-10 items-center justify-center rounded-full border-[1px] border-tabs-border bg-backgroundBrand p-1 text-muted-foreground", className)
    }, props));
});
TabsList.displayName = _radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_2__/* .List.displayName */ .aV.displayName;
var TabsTrigger = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("inline-flex items-center justify-center whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-tabs-accent data-[state=active]:text-tabs-accentForeground data-[state=active]:shadow-sm", className)
    }, props));
});
TabsTrigger.displayName = _radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_2__/* .Trigger.displayName */ .xz.displayName;
var TabsContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className)
    }, props));
});
TabsContent.displayName = _radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;



/***/ }),

/***/ 54504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/utils.ts + 11 modules
var utils = __webpack_require__(74183);
// EXTERNAL MODULE: ./components/ui/typography.tsx
var typography = __webpack_require__(58020);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/forms/SignUpForm.tsx
var SignUpForm = __webpack_require__(5138);
// EXTERNAL MODULE: ./components/CodeOfConductModal.tsx
var CodeOfConductModal = __webpack_require__(83642);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/play-circle.js
var play_circle = __webpack_require__(4171);
// EXTERNAL MODULE: ./components/ui/dialog.tsx
var dialog = __webpack_require__(70499);
// EXTERNAL MODULE: ./components/Recaptcha.tsx
var Recaptcha = __webpack_require__(70822);
// EXTERNAL MODULE: ./components/AuthSection.tsx + 3 modules
var AuthSection = __webpack_require__(72557);
// EXTERNAL MODULE: ./util/auth.tsx + 1 modules
var util_auth = __webpack_require__(19475);
;// CONCATENATED MODULE: ./components/HeroSection.tsx




var ReactPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 712).then(__webpack_require__.t.bind(__webpack_require__, 40712, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40712)
            ];
        }
    },
    ssr: false
});












var HeroSection = function(props) {
    var auth = (0,util_auth/* useAuth */.aC)();
    var formId = react.useId();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isCodeOfConductModalOpen = ref[0], setIsCodeOfConductModalOpen = ref[1];
    var onSubmit = (0,AuthSection/* useAuthSubmitHandlers */.XH)({
        afterAuthPath: "/",
        onError: function(error) {
            console.log("ERROR", error);
        },
        type: AuthSection/* AuthSectionType.SignUp */._I.SignUp
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "grid grid-cols-12 gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-12 lg:col-span-5 xl:col-span-6 flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/media/2023/team-solid.svg",
                            width: 756,
                            height: 377,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-12 lg:col-span-7 xl:col-span-6 bg-white rounded-lg py-2 sm:py-6 px-2 sm:px-10 grid grid-cols-12 gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-12 flex flex-col gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: "h1",
                                        children: "Grow your skills to lead in the multicultural world!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: "large",
                                        children: "Join our diverse leaders’ community for collaborative learning and experience sharing"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-12 xl:col-span-10 2xl:col-span-8 flex flex-col gap-6",
                                children: [
                                    !auth.isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm/* SignUpForm */.W, {
                                        onSubmit: onSubmit,
                                        formId: formId
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            auth.isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: "/self-assessment",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                    size: "lg",
                                                    asChild: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "Take assessment"
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                type: "submit",
                                                size: "lg",
                                                form: formId,
                                                className: "flex-1",
                                                children: "Sign up"
                                            }),
                                            !!props.video && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.Vq, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTrigger */.hg, {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                                                            type: "button",
                                                            size: "lg",
                                                            variant: "outline",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(play_circle/* default */.Z, {
                                                                    className: "w-4 h-4"
                                                                }),
                                                                "What is Casehub"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
                                                        className: "w-full max-w-screen sm:max-w-screen-lg sm:w-2/3 lg:w-1/2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogHeader */.fK, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTitle */.$N, {
                                                                    children: "What is Casehub"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "aspect-video w-full",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                                                                    video: props.video
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !auth.isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    variant: "muted",
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "By signing up, you accept our",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/content/terms",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (0,utils.cn)((0,ui_button/* buttonVariants */.d)({
                                                        variant: "link"
                                                    }), "p-0 h-auto"),
                                                    target: "_blank",
                                                    rel: "nofollow noopener",
                                                    children: "Terms of use"
                                                })
                                            }),
                                            " ",
                                            "and",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                variant: "link",
                                                className: "p-0 h-auto",
                                                onClick: function() {
                                                    setIsCodeOfConductModalOpen(true);
                                                },
                                                children: "Code of Conduct"
                                            })
                                        ]
                                    })
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeOfConductModal/* default */.Z, {
                open: isCodeOfConductModalOpen,
                onOpenChange: setIsCodeOfConductModalOpen
            })
        ]
    });
};
var Video = function(param) {
    var video = param.video;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "aspect-video relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
            className: "absolute inset-0",
            url: "https://vimeo.com/".concat(video),
            controls: true,
            width: "100%",
            height: "100%",
            config: {
                playerOptions: {
                    responsive: true,
                    title: false,
                    byline: false,
                    portrait: false
                }
            }
        })
    });
};
/* harmony default export */ var components_HeroSection = ((0,Recaptcha/* RecaptchaComponent */.w)(HeroSection));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/ui/avatar.tsx + 1 modules
var avatar = __webpack_require__(93310);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/quote.js
var quote = __webpack_require__(66960);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/pause.js
var pause = __webpack_require__(56179);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/play.js
var play = __webpack_require__(49482);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js + 2 modules
var embla_carousel_react_esm = __webpack_require__(89382);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-left.js
var arrow_left = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-right.js
var arrow_right = __webpack_require__(82701);
;// CONCATENATED MODULE: ./components/ui/carousel.tsx
"use client";










var CarouselContext = /*#__PURE__*/ react.createContext(null);
function useCarousel() {
    var context = react.useContext(CarouselContext);
    if (!context) {
        throw new Error("useCarousel must be used within a <Carousel />");
    }
    return context;
}
var Carousel = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var _orientation = _param.orientation, orientation = _orientation === void 0 ? "horizontal" : _orientation, opts = _param.opts, setApi = _param.setApi, plugins = _param.plugins, className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "orientation",
        "opts",
        "setApi",
        "plugins",
        "className",
        "children"
    ]);
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,embla_carousel_react_esm/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, opts), {
        axis: orientation === "horizontal" ? "x" : "y"
    }), plugins), 2), carouselRef = _$ref[0], api = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), canScrollPrev = _$ref1[0], setCanScrollPrev = _$ref1[1];
    var _$ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), canScrollNext = _$ref2[0], setCanScrollNext = _$ref2[1];
    var _$ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), selectedIndex = _$ref3[0], setSelectedIndex = _$ref3[1];
    var onSelect = react.useCallback(function(api) {
        if (!api) {
            return;
        }
        setCanScrollPrev(api.canScrollPrev());
        setCanScrollNext(api.canScrollNext());
        setSelectedIndex(api.selectedScrollSnap());
    }, []);
    var scrollPrev = react.useCallback(function() {
        api === null || api === void 0 ? void 0 : api.scrollPrev();
    }, [
        api
    ]);
    var scrollNext = react.useCallback(function() {
        api === null || api === void 0 ? void 0 : api.scrollNext();
    }, [
        api
    ]);
    var handleKeyDown = react.useCallback(function(event) {
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            scrollPrev();
        } else if (event.key === "ArrowRight") {
            event.preventDefault();
            scrollNext();
        }
    }, [
        scrollPrev,
        scrollNext
    ]);
    var scrollTo = react.useCallback(function(index) {
        api === null || api === void 0 ? void 0 : api.scrollTo(index);
    }, [
        api
    ]);
    react.useEffect(function() {
        if (!api || !setApi) {
            return;
        }
        setApi(api);
    }, [
        api,
        setApi
    ]);
    react.useEffect(function() {
        if (!api) {
            return;
        }
        onSelect(api);
        api.on("reInit", onSelect);
        api.on("select", onSelect);
        return function() {
            api === null || api === void 0 ? void 0 : api.off("select", onSelect);
        };
    }, [
        api,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContext.Provider, {
        value: {
            carouselRef: carouselRef,
            api: api,
            opts: opts,
            orientation: orientation || ((opts === null || opts === void 0 ? void 0 : opts.axis) === "y" ? "vertical" : "horizontal"),
            scrollPrev: scrollPrev,
            scrollNext: scrollNext,
            canScrollPrev: canScrollPrev,
            canScrollNext: canScrollNext,
            selectedIndex: selectedIndex,
            scrollTo: scrollTo
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            onKeyDownCapture: handleKeyDown,
            className: (0,utils.cn)("relative", className),
            role: "region",
            "aria-roledescription": "carousel"
        }, props), {
            children: children
        }))
    });
});
Carousel.displayName = "Carousel";
var CarouselContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var _$ref = useCarousel(), carouselRef = _$ref.carouselRef, orientation = _$ref.orientation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: carouselRef,
        className: "overflow-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
            ref: ref,
            className: (0,utils.cn)("flex", orientation === "horizontal" ? "-ml-4" : "-mt-4 flex-col", className)
        }, props))
    });
});
CarouselContent.displayName = "CarouselContent";
var CarouselItem = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var orientation = useCarousel().orientation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        role: "group",
        "aria-roledescription": "slide",
        className: (0,utils.cn)("min-w-0 shrink-0 grow-0 basis-full", orientation === "horizontal" ? "pl-4" : "pt-4", className)
    }, props));
});
CarouselItem.displayName = "CarouselItem";
var CarouselPrevious = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var className = _param.className, _variant = _param.variant, variant = _variant === void 0 ? "outline" : _variant, _size = _param.size, size = _size === void 0 ? "icon" : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "variant",
        "size"
    ]);
    var _$ref = useCarousel(), orientation = _$ref.orientation, scrollPrev = _$ref.scrollPrev, canScrollPrev = _$ref.canScrollPrev;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        variant: variant,
        size: size,
        className: (0,utils.cn)("absolute  h-8 w-8 rounded-full", orientation === "horizontal" ? "-left-12 top-1/2 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90", className),
        disabled: !canScrollPrev,
        onClick: scrollPrev
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_left/* default */.Z, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Previous slide"
            })
        ]
    }));
});
CarouselPrevious.displayName = "CarouselPrevious";
var CarouselNext = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var className = _param.className, _variant = _param.variant, variant = _variant === void 0 ? "outline" : _variant, _size = _param.size, size = _size === void 0 ? "icon" : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "variant",
        "size"
    ]);
    var _$ref = useCarousel(), orientation = _$ref.orientation, scrollNext = _$ref.scrollNext, canScrollNext = _$ref.canScrollNext;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        variant: variant,
        size: size,
        className: (0,utils.cn)("absolute h-8 w-8 rounded-full", orientation === "horizontal" ? "-right-12 top-1/2 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90", className),
        disabled: !canScrollNext,
        onClick: scrollNext
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Next slide"
            })
        ]
    }));
});
CarouselNext.displayName = "CarouselNext";
var CarouselDots = /*#__PURE__*/ react.forwardRef(function(_param) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var ref;
    var ref1 = useCarousel(), selectedIndex = ref1.selectedIndex, scrollTo = ref1.scrollTo, api = ref1.api;
    var handleScrollTo = function(index) {
        return function() {
            return scrollTo(index);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils.cn)("mt-8 flex items-center justify-center gap-1", className)
    }, props), {
        children: (ref = api === null || api === void 0 ? void 0 : api.scrollSnapList()) === null || ref === void 0 ? void 0 : ref.map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                className: (0,utils.cn)("bg-gray-200 hover:bg-gray-400 h-[6px] w-2 rounded-full py-0", {
                    "bg-gray-400": index === selectedIndex
                }),
                onClick: handleScrollTo(index)
            }, index);
        })
    }));
});
CarouselDots.displayName = "CarouselDots";


// EXTERNAL MODULE: ./components/ui/card.tsx
var card = __webpack_require__(64345);
;// CONCATENATED MODULE: ./components/TestimonialsSection.tsx













var TestimonialsSection_ReactPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 712).then(__webpack_require__.t.bind(__webpack_require__, 40712, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40712)
            ];
        }
    },
    ssr: false
});

var getUserInitials = function(name) {
    return name.split(" ").map(function(it) {
        return it[0].toUpperCase();
    }).join("");
};
var TestimonialsSection = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState({}), 2), activeVideos = ref[0], setActiveVideos = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), playingVideo = ref1[0], setPlayingVideo = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container my-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                className: "text-center text-sm tracking-widest uppercase leading-relaxed font-bold",
                children: "client experiences"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: "h2",
                className: "text-center pb-8 border-0",
                children: "Client’s feedback"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Carousel, {
                className: "w-full",
                opts: {
                    containScroll: "trimSnaps"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContent, {
                        children: props.items.map(function(it, index) {
                            var ref = (0,_sliced_to_array/* default */.Z)(it.auto_highlight ? splitText(it.text) : [
                                "",
                                it.text
                            ], 2), firstSentence = ref[0], restText = ref[1];
                            var isActiveVideo = activeVideos[index];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                                className: "flex md:basis-1/2 xl:basis-1/3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex p-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* Card */.Zb, {
                                        className: "flex shadow-lg rounded-lg border-[1px] bg-white hover:bg-teal-50 border-gray-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* CardContent */.aY, {
                                            className: "flex flex-col justify-center p-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(quote/* default */.Z, {
                                                    className: "w-10 h-10 mb-3 text-teal-200 rotate-180",
                                                    strokeWidth: 1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col gap-2 mb-12",
                                                    children: [
                                                        firstSentence ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                            variant: "h3",
                                                            className: "text-lg",
                                                            children: firstSentence
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                            variant: "muted",
                                                            className: "text-sm",
                                                            children: restText
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-end mt-auto gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "relative",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "w-[140px] h-[140px] rounded",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(avatar/* Avatar */.qE, {
                                                                            className: (0,utils.cn)("w-[140px] h-[140px]", {
                                                                                "hidden": isActiveVideo
                                                                            }),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* AvatarImage */.F$, {
                                                                                    src: it.image,
                                                                                    alt: it.title
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* AvatarFallback */.Q5, {
                                                                                    children: getUserInitials(it.title)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        it.video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (0,utils.cn)("bg-muted relative overflow-hidden rounded-full border-2 border-avatarBorder w-[140px] h-[140px]", {
                                                                                "hidden": !isActiveVideo
                                                                            }),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsSection_Video, {
                                                                                video: it.video,
                                                                                playing: playingVideo === index
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                it.video && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                                    onClick: function() {
                                                                        setPlayingVideo(playingVideo === index ? null : index);
                                                                        setActiveVideos((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activeVideos), (0,_define_property/* default */.Z)({}, index, true)));
                                                                    },
                                                                    size: "icon",
                                                                    className: "h-12 w-12 absolute top-[0px] right-[-24px]",
                                                                    children: playingVideo === index ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pause/* default */.Z, {
                                                                        className: "w-6 h-6",
                                                                        strokeWidth: 1
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(play/* default */.Z, {
                                                                        className: "w-6 h-6",
                                                                        strokeWidth: 1
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-md font-medium leading-none",
                                                                    children: it.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-xs text-muted-foreground",
                                                                    children: it.subtitle
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, it.title);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselDots, {})
                ]
            })
        ]
    });
};
function splitText(text) {
    var match = text.match(RegExp("(.*?[.!?])\\s*(.*)", "s"));
    if (match) {
        return [
            match[1],
            match[2]
        ];
    }
    // if no match, return the whole text as the first sentence, and an empty string as the rest
    return [
        text,
        ""
    ];
}
var TestimonialsSection_Video = function(param) {
    var video = param.video, playing = param.playing;
    var playerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), setIsReady = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            position: "relative",
            paddingTop: "100%",
            width: "280px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsSection_ReactPlayer, {
            ref: playerRef,
            url: video,
            controls: false,
            playing: playing,
            width: "100%",
            height: "100%",
            style: {
                position: "absolute",
                top: 0,
                left: -70
            },
            onReady: function() {
                return setIsReady(true);
            },
            playbackRate: 1,
            config: {
                playerOptions: {
                    // responsive: true,
                    title: false,
                    byline: false,
                    portrait: false
                }
            }
        })
    });
};
/* harmony default export */ var components_TestimonialsSection = (TestimonialsSection);

// EXTERNAL MODULE: ./util/format.ts + 9 modules
var format = __webpack_require__(16685);
// EXTERNAL MODULE: ./node_modules/keen-slider/react.js
var keen_slider_react = __webpack_require__(82730);
;// CONCATENATED MODULE: ./components/ClientsSection.tsx






var animation = {
    duration: 20000 * 2.5,
    easing: function(t) {
        return t;
    }
};
var ClientsSection = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, title = param.title, anchor = param.anchor, className = param.className;
    var anchorId = (0,format/* prepareAnchorId */.iS)(anchor);
    var callbacksRefs = react.useRef([]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,keen_slider_react/* useKeenSlider */.E)({
        loop: true,
        mode: "free",
        slides: {
            perView: 5,
            spacing: 15
        },
        drag: false,
        created: function created(s) {
            var onMouseOver = function() {
                s.animator.stop();
            };
            var onMouseOut = function() {
                s.moveToIdx(s.track.details.abs + 5, true, animation);
            };
            callbacksRefs.current.push({
                type: "mouseover",
                fn: onMouseOver
            });
            callbacksRefs.current.push({
                type: "mouseout",
                fn: onMouseOut
            });
            s.container.addEventListener("mouseover", onMouseOver);
            s.container.addEventListener("mouseout", onMouseOut);
            s.moveToIdx(5, true, animation);
        },
        destroyed: function destroyed(s) {
            callbacksRefs.current.forEach(function(param) {
                var type = param.type, fn = param.fn;
                s.container.removeEventListener(type, fn);
            });
            callbacksRefs.current = [];
        },
        updated: function updated(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
        animationEnded: function animationEnded(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        }
    }), 1), sliderRef = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: anchorId,
        className: (0,utils.cn)(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: sliderRef,
            className: "keen-slider",
            children: items.map(function(it) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "keen-slider__slide",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center filter grayscale hover:grayscale-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hover:text-gray-900 dark:hover:text-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "h-16 w-28 object-scale-down",
                                src: it.image,
                                alt: it.name
                            })
                        })
                    }, it.image)
                }, it.name + "_" + it.image);
            })
        })
    });
};
/* harmony default export */ var components_ClientsSection = (ClientsSection);

// EXTERNAL MODULE: ./components/ui/tabs.tsx
var tabs = __webpack_require__(35895);
;// CONCATENATED MODULE: ./components/TeamSection.tsx











var TeamSection = function(props) {
    if (!props.members || !props.members.length) {
        return null;
    }
    var groupedMembers = useGroupedMembers(props.members);
    var anchorId = (0,format/* prepareAnchorId */.iS)(props.anchor);
    var allGroups = Object.keys(groupedMembers);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container my-20",
        id: anchorId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                className: "text-center text-sm tracking-widest uppercase leading-relaxed font-bold",
                children: "casehub team"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: "h2",
                className: "text-center pb-8 border-0",
                children: "Meet your coaches and facilitators"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tabs */.mQ, {
                defaultValue: "coach",
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center mb-6",
                        children: allGroups.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsList */.dr, {
                            className: "grid grid-cols-2 inline-flex",
                            children: Object.entries(groupedMembers).map(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), group = _param[0], members = _param[1];
                                var ref;
                                var groups = Array.isArray(members[0].group) ? members[0].group : [
                                    members[0].group
                                ];
                                var label = (ref = groups === null || groups === void 0 ? void 0 : groups.find(function(it) {
                                    return it.value === group;
                                })) === null || ref === void 0 ? void 0 : ref.label;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                    value: group,
                                    children: label
                                }, label + "_" + group);
                            })
                        })
                    }),
                    Object.entries(groupedMembers).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), group = _param[0], members = _param[1];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                            value: group,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid gap-4 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4",
                                children: members.map(function(it) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {
                                        name: it.name,
                                        image: it.image,
                                        text: it.text,
                                        description: it.description,
                                        link: it.link
                                    }, "".concat(it.name, "_").concat(it.group[0].value));
                                })
                            })
                        }, group);
                    })
                ]
            })
        ]
    });
};
var useGroupedMembers = function(members) {
    var groupedMembers = (0,react.useMemo)(function() {
        var filteredMembers = members.filter(function(it) {
            return it.name;
        });
        return filteredMembers.reduce(function(acc, it) {
            var groups = Array.isArray(it.group) ? it.group : [
                it.group
            ];
            var addToGroup = function(group, member) {
                if (!acc[group]) {
                    acc[group] = [];
                }
                acc[group].push(member);
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var group = _step.value;
                    if (!group) {
                        continue;
                    }
                    addToGroup(group.value ? group.value : group, it);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return acc;
        }, {});
    }, [
        members
    ]);
    return groupedMembers;
};
var MemberWrapper = function(param) {
    var link = param.link, children = param.children, className = param.className;
    if (!link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (0,utils.cn)("cursor-pointer", className),
            target: "_blank",
            children: children
        })
    });
};
var Member = function(param) {
    var name = param.name, image = param.image, text = param.text, description = param.description, link = param.link;
    var initials = name.split(" ").map(function(it) {
        return it[0];
    }).join("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MemberWrapper, {
        link: link,
        className: (0,utils.cn)("group rounded-lg shadow-lg bg-teal-50 border-[1px] p-4 relative overflow-hidden min-h-[180px]", {
            "cursor-pointer": !!link
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 absolute inset-0 bg-teal-200 group-hover:h-20 group-hover:bg-transparent p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(avatar/* Avatar */.qE, {
                        className: "w-[148px] h-[148px] aspect-square group-hover:h-12 group-hover:w-12 transition-all duration-300 rounded-[8px] group-hover:rounded-[40px] border-transparent group-hover:border-avatarBorder",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* AvatarImage */.F$, {
                                src: image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* AvatarFallback */.Q5, {
                                children: initials
                            })
                        ]
                    }),
                    !!name ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "self-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-gray-800 font-medium leading-none",
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-gray-800 text-xs",
                                children: text
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-7",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: "blockquote",
                    className: "border-teal-200 pl-2 line-clamp-4 text-gray-600 text-sm",
                    children: description
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* Card */.Zb, {
        className: "animate-in slide-in-from-right-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardHeader */.Ol, {
                className: "rounded-lg overflow-hidden px-0 pt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* CardContent */.aY, {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardTitle */.ll, {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* CardDescription */.SZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "block",
                                children: text
                            }),
                            description
                        ]
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: link,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            asChild: true,
                            variant: "ghost",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Read more"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TeamSection = (TeamSection);

// EXTERNAL MODULE: ./components/SeoTags.tsx
var SeoTags = __webpack_require__(47460);
// EXTERNAL MODULE: ./components/icons.tsx + 14 modules
var icons = __webpack_require__(43936);
;// CONCATENATED MODULE: ./components/CtaCard.tsx








var CtaCard = function(param) {
    var title = param.title, text = param.text, image = param.image, _layout = param.layout, layout = _layout === void 0 ? "default" : _layout, _buttons = param.buttons, buttons = _buttons === void 0 ? [] : _buttons, showLogo = param.showLogo, className = param.className, actionsNote = param.actionsNote;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,utils.cn)("bg-teal-500", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-12 sm:p-12 gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-12 lg:col-span-6 lg:flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image,
                            width: 756,
                            height: 413
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,utils.cn)("col-span-12 lg:col-span-6 flex flex-col items-start justify-center", {
                            "lg:order-first": layout === "reverse"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-2 col-span-12 2xl:col-span-8",
                                    children: [
                                        showLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center gap-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icons.logo */.P.logo, {
                                                className: "mr-2 h-8 w-auto mb-8 text-white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                            variant: "h1",
                                            className: "text-white",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                            variant: "large",
                                            className: "text-white",
                                            children: text
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-8 mb-4 col-span-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex gap-2",
                                            children: buttons.map(function(button, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: button.href,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                        variant: button.variant,
                                                        environment: button.environment,
                                                        size: button.size,
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: button.title
                                                        })
                                                    })
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                            variant: "muted",
                                            className: "mt-4",
                                            children: actionsNote
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_CtaCard = (CtaCard);

// EXTERNAL MODULE: ./util/hooks/useLocalStorage.js
var useLocalStorage = __webpack_require__(61959);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./util/assessment.js
var assessment = __webpack_require__(21757);
;// CONCATENATED MODULE: ./components/SelfAssessmentModal.tsx










var useSelfAssessmentStorage = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)("self-assessment-notified", null), 2), notifiedTimestamp = ref[0], setNotifiedTimestamp = ref[1];
    return [
        notifiedTimestamp,
        setNotifiedTimestamp
    ];
};
var useShouldShowModal = function(notifiedTimestamp) {
    var ref = (0,react.useState)(false), shouldShow = ref[0], setShouldShow = ref[1];
    var auth = (0,util_auth/* useAuth */.aC)();
    var parsedTs = parseInt(notifiedTimestamp, 10);
    var hasBeenNotified = parsedTs ? Date.now() - parsedTs < 2 * 24 * 60 * 60 * 1000 : null;
    (0,react.useEffect)(function() {
        if (auth.isAuthenticated) {
            (0,assessment/* fetchSelfAssessment */.H7)().then(function(response) {
                var alreadyCompletedAssessment = Object.keys(response || {}).length > 0;
                setShouldShow(!alreadyCompletedAssessment);
            });
        }
    }, [
        auth.isAuthenticated
    ]);
    if (!auth.isAuthenticated || hasBeenNotified) {
        return false;
    }
    return shouldShow;
};
var SelfAssessmentModal = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(useSelfAssessmentStorage(), 2), notifiedTimestamp = ref[0], setNotifiedTimestamp = ref[1];
    var updateNotificationTime = (0,react.useCallback)(function() {
        setNotifiedTimestamp(Date.now());
    }, []);
    var shouldShow = useShouldShowModal(notifiedTimestamp);
    if (!shouldShow) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: shouldShow,
        onOpenChange: function() {
            updateNotificationTime();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:max-w-[425px] bg-backgroundBrand",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogHeader */.fK, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTitle */.$N, {
                        children: "Take your leadership assessment now!"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid gap-4 py-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            children: "It takes 15 minutes to complete. Once submitted, you will immediately receive your results and a leadership excellence score."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            children: "Then you'll be ready to create your personal training programme"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogFooter */.cN, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "secondary",
                            onClick: function() {
                                updateNotificationTime();
                            },
                            children: "Remind me later"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            onClick: function() {
                                updateNotificationTime();
                                router.push("/self-assessment");
                            },
                            children: "Start here"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(46035);
// EXTERNAL MODULE: ./features/casesSlice.ts
var casesSlice = __webpack_require__(94916);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/cards/CaseCard.tsx
var CaseCard = __webpack_require__(65558);
;// CONCATENATED MODULE: ./components/ScheduledClassesCarouselSection.tsx









var scheduledCasesSelector = (0,casesSlice/* makeGetCaseByStatus */.uU)({
    selectedStatus: [
        constants/* CaseStatuses.SCHEDULED */.HM.SCHEDULED,
        constants/* CaseStatuses.TENTATIVE */.HM.TENTATIVE
    ],
    sortKey: "scheduled_to"
});
var maxCases = 4;
var ScheduledClassesCarouselSection = function() {
    var scheduledCases = (0,es/* useSelector */.v9)(scheduledCasesSelector);
    var closedCases = (0,es/* useSelector */.v9)(function(state) {
        return (0,casesSlice/* makeGetClosedCases */.Ed)("desc")(state);
    });
    var freeCases = closedCases.filter(function(c) {
        return c.public;
    }).slice(0, maxCases);
    var popularCases = (0,_to_consumable_array/* default */.Z)(closedCases).concat((0,_to_consumable_array/* default */.Z)(scheduledCases)).sort(function(a, b) {
        return b.comment_count + b.register_count - (a.comment_count + a.register_count);
    }).slice(0, maxCases);
    var upcomingCases = (0,_to_consumable_array/* default */.Z)(scheduledCases).sort(function(a, b) {
        return a.scheduled_to - b.scheduled_to;
    }).slice(0, maxCases);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container my-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                className: "text-center text-sm tracking-widest uppercase leading-relaxed font-bold",
                children: "materials"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: "h2",
                className: "text-center pb-8 border-0",
                children: "Live group sessions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tabs */.mQ, {
                defaultValue: "upcoming",
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center mb-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* TabsList */.dr, {
                            className: "m-auto flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                    value: "free",
                                    children: "Free"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                    value: "upcoming",
                                    children: "Upcoming"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                    value: "popular",
                                    children: "Past"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                        value: "free",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                            cases: freeCases
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                        value: "upcoming",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                            cases: upcomingCases
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                        value: "popular",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                            cases: popularCases
                        })
                    })
                ]
            })
        ]
    });
};
var List = function(param) {
    var cases = param.cases;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 lg:grid-cols-[repeat(auto-fit,_minmax(0,calc(25%_-_1rem)))] mx-auto gap-4 justify-center",
        children: cases.map(function(currentCase) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCard/* default */.Z, {
                caseId: currentCase.id
            }, currentCase.id);
        })
    });
};

// EXTERNAL MODULE: ./components/ListCta.tsx
var ListCta = __webpack_require__(79992);
;// CONCATENATED MODULE: ./components/TrainingZonesStatic.tsx







var TrainingZonesStatic = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, title = param.title, anchor = param.anchor, imgSrc = param.imgSrc, imgWidth = param.imgWidth, imgHeight = param.imgHeight, imagePosition = param.imagePosition;
    var anchorId = (0,format/* prepareAnchorId */.iS)(anchor);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: anchorId,
        className: "my-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: "h2",
                className: "text-center pb-8 border-0",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,utils.cn)("bg-footer rounded text-footer-foreground grid lg:grid-flow-col p-6 gap-4 relative shadow-lg [&>*]:border-b-[1px] [&>*]:lg:border-b-0 [&>*:not(:last-child)]:lg:border-r-[1px] [&>*:not(:last-child)]:border-teal-300"),
                children: [
                    imagePosition === ListCta/* ImagePosition.Left */.O.Left && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,utils.cn)("hidden lg:flex items-center lg:col-span-3 px-4"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative -mt-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imgSrc,
                                width: imgWidth,
                                height: imgHeight
                            })
                        })
                    }),
                    items.map(function(it) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "px-4 col-span-12 lg:col-span-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "font-bold text-xl mb-2",
                                    children: it.title
                                }),
                                it.text
                            ]
                        }, it.title);
                    }),
                    imagePosition === ListCta/* ImagePosition.Right */.O.Right && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,utils.cn)("hidden lg:flex items-center lg:col-span-3 justify-self-end"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative -mt-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imgSrc,
                                width: imgWidth,
                                height: imgHeight
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TrainingZonesStatic = (TrainingZonesStatic);

;// CONCATENATED MODULE: ./pages/index.tsx













var getDynamicFieldValue = function(field, isLoggedIn) {
    if (!field) {
        return "";
    }
    return isLoggedIn ? field.logged_in : field.base;
};
function IndexPage(param) {
    var content = param.content;
    var auth = (0,util_auth/* useAuth */.aC)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* default */.Z, {
                config: content.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-gradient-to-b from-0% from-teal-200 to-80% to-white pt-16 gap-4 flex flex-col",
                children: [
                    content.hero_1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HeroSection, {
                        title: content.hero_1.title,
                        subtitle: content.hero_1.subtitle,
                        image: content.hero_1.image,
                        video: content.hero_1.video,
                        buttonPrimary: content.hero_1.button_primary ? {
                            title: getDynamicFieldValue(content.hero_1.button_primary.title, auth.isAuthenticated),
                            path: getDynamicFieldValue(content.hero_1.button_primary.path, auth.isAuthenticated),
                            helpText: getDynamicFieldValue(content.hero_1.button_primary.help_text, auth.isAuthenticated)
                        } : undefined
                    }),
                    content.clients ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClientsSection, {
                        className: "border-t-[1px] border-gray-200 py-6",
                        title: content.clients.title,
                        items: content.clients.list,
                        anchor: content.clients.anchor
                    }) : null
                ]
            }),
            content.training_zones && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TrainingZonesStatic, {
                    imagePosition: ListCta/* ImagePosition.Left */.O.Left,
                    imgWidth: 330,
                    imgHeight: 288,
                    imgSrc: "/media/2023/woman.svg",
                    title: "Your tailored growth journey" || 0,
                    items: [
                        {
                            title: "Personalised approach",
                            text: "Follow a development programme tailored to your needs, shaped by self-assessment and 360 feedback."
                        },
                        {
                            title: "Practical leadership scenarios",
                            text: "Engage in solving real-world leadership challenges, supported by a curated set of tools from CaseHub."
                        },
                        {
                            title: "Cross-cultural inspiration",
                            text: "Experience enriching collaborative sessions with global leaders, paired with a training buddy and dedicated personal coaching."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduledClassesCarouselSection, {}),
            content.fitness_score_cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CtaCard, {
                title: "What is your level of leadership excellence?",
                text: "Take our leadership assessment to find it out and understand your development needs",
                image: "/media/2023/faq.svg",
                buttons: [
                    {
                        title: "Start here",
                        href: "/self-assessment",
                        size: "lg"
                    }, 
                ]
            }),
            content.our_team && content.our_team.visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TeamSection, {
                title: content.our_team.title,
                members: content.our_team.list,
                anchor: content.our_team.anchor
            }),
             false && /*#__PURE__*/ 0,
            content.testimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TestimonialsSection, {
                items: content.testimonials.list
            }),
            !auth.isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CtaCard, {
                    className: "bg-teal-400 mb-24 rounded-sm",
                    title: "Start for free",
                    text: "Satisfy your curiosity. Start your journey by signing up today.",
                    image: "/media/2023/process.svg",
                    layout: "reverse",
                    buttons: [
                        {
                            title: "Sign up",
                            href: "/auth/signup"
                        },
                        {
                            title: "Ask a question",
                            href: "/contact",
                            variant: "outline",
                            environment: "light"
                        }, 
                    ],
                    actionsNote: "Full access for 14 days. No credit card required."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelfAssessmentModal, {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var pages = (IndexPage);


/***/ })

}]);